import { Component } from "react";
import DialogTitleWithCloseButton from "./DialogTitleWithCloseButton";
import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import SearchItem from './SearchItem';
import request from "../request";
import { errorToast } from "../toast";
import swal from "sweetalert";


export class ConnectEntityToQuickbooks extends Component {

   state = {
      loading: false,
      selectedItem: null,
      connectToNew: false
   }

   submit = async () => {

      // validate
      const connectToNew = this.state.connectToNew;

      if (!connectToNew && !this.state.selectedItem) {
         errorToast("Please select an entity");
         return;
      }

      const extraFields = {}

      if (connectToNew) {
         // validate extra fields
         if (this.props.extraFields) {
            for (const field of this.props.extraFields) {
               if (field.required && this.state[field.name] === '') {
                  errorToast(`Please fill in ${field.label}`);
                  return;
               }

               extraFields[field.name] = this.state[field.name];
            }
         }
      }

      // submit
      try {

         // show loading indicator
         this.setState({ loading: true });

         // prepare data
         const data = {
            [this.props.entityKey]: this.props.entityId
         };

         if (connectToNew) {
            for (const field in extraFields) {
               data[field] = extraFields[field];
            }
         } else {
            const quickbooksIdKey = this.props.quickbooksIdKey || "quickbooks_id";
            data[quickbooksIdKey] = this.state.selectedItem.id;
         }

         // send request
         const res = await request.post(this.props.submitUrl, data);
         swal("Success", "Connected successfully", "success");

         // close dialog
         this.props.onClose(res.data);
         
      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         this.setState({ loading: false });
      }
   }

   render() {

      let content;

      if (this.state.loading) {
         content = <div className="flex items-center justify-center h-[400px]">
            <CircularProgress />
         </div>
      } else {
         content = <>
            <div className="flex items-center">
               <Checkbox
                  value={this.state.connectToNew}
                  onChange={e => this.setState({ connectToNew: e.currentTarget.checked })}
               />
               <span>
                  Connect to new
               </span>
            </div>
            {
               (!this.props.extraFields || !this.state.connectToNew) && <SearchItem
                  fetchData={this.props.fetchData}
                  renderOption={this.props.renderOption}
                  transformOption={option => ({ ...option, label: option.name })}
                  value={this.state.selectedItem}
                  onChange={selectedItem => this.setState({ selectedItem })}
                  size="small"
                  label="Select an entity"
                  disabled={this.state.connectToNew}
               />
            }
            {
               this.props.extraFields && this.state.connectToNew && <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {
                     this.props.extraFields.map((field, index) => {
                        return <TextField
                           key={index}
                           label={field.label}
                           value={this.state[field.name]}
                           onChange={e => this.setState({ [field.name]: e.target.value })}
                           size="small"
                           type={field.type || "text"}
                           fullWidth
                           slotProps={field.type === 'date' ? {
                              inputLabel: {
                                 shrink: true
                              }
                           } : {}}
                        />
                     })
                  }
               </div>
            }
         </>
      }

      return <Dialog open maxWidth="xs" >
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            {this.props.title || "Connect to Quickbooks"}
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="flex flex-col gap-4">
               {content}
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant="contained" onClick={this.submit}>
               Connect
            </Button>
         </DialogActions>
      </Dialog>
   }
}